import {
    SET_RESULTS_MONTHLY_CHART,
    SET_RESULTS_ANNUAL_CHART,
    SET_RESULTS_WEEKLY_CHART,
    SET_RESULTS_HAPPINESS,
} from "@/views/chart/store/types/types.js";

const mutations = {
    [SET_RESULTS_MONTHLY_CHART]: (state, payload) => state.resultsMonthlyChart = payload,
    [SET_RESULTS_ANNUAL_CHART]: (state, payload) => state.resultsAnnualChart = payload,
    [SET_RESULTS_WEEKLY_CHART]: (state, payload) => state.resultsWeeklyChart = payload,
    [SET_RESULTS_HAPPINESS]: (state, payload) => state.resultsHappiness = payload,
};

export default mutations